
// import React, { useCallback, useEffect, useState } from 'react';
// import NonFSIndex from "@dndComponents/NonFSIndex";
// import { 
//   FeatureSource, 
//   ModelBase, 
//   OptionalFeatureBase, 
//   PlayerObject 
// } from "@models";
// import { Creature, CreatureAbility, StandardFeatures, Transform } from "@dndModels";
// import { DATA_TYPE_INFO, FEATURE_SOURCE_TYPES } from "@dndModels/Constants";

// import DandDAPI from "@dndUtilities/system_api";
// import LoadingBox from "@components/input/LoadingBox";
// import { DataType } from '@dndModels/Types';
// import Grid from '@mui/material/Grid2';
// import ButtonBox from '@components/input/buttons/ButtonBox';

// const api = DandDAPI.getInstance();

// export default function CreatureFeatureIndex() {
//   const [fetched, setFetched] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [loading_message, setLoadingMessage] = useState("");
//   const [percentage, setPercentage] = useState(0);
//   const [creatures, setCreatures] = useState<Creature[]>([]);
//   const [transforms, setTransforms] = useState<Transform[]>([]);
//   const [ofbs, setOFBs] = useState<OptionalFeatureBase[]>([]);
//   const [standard_features, setStandardFeatures] = useState<StandardFeatures[]>([]);

//   const load = useCallback( async () => {
//     const onProgress = (data_type: DataType, percent: number) => {
//       const dt_info = DATA_TYPE_INFO.find(o => o.data_type === data_type);
//       setPercentage(percent * 100);
//       setLoadingMessage(`Loading ${dt_info?.plural??""}`);
//     }

//     const res = await api.getSetOfObjectsWithCallbacks({ 
//       data_types: [
//         ...FEATURE_SOURCE_TYPES,
//         "creature","transform","optional_feature_base","standard_features"
//       ],
//       load_all: true, onProgress
//     });
//     setCreatures(res.creature as Creature[]);
//     setTransforms(res.transform as Transform[]);
//     setOFBs(res.optional_feature_base as OptionalFeatureBase[]);
//     setStandardFeatures(res.standard_features as StandardFeatures[]);
//     setLoading(false);
//   }, []);

//   // eslint-disable-next-line
//   useEffect(() => {
//     if (!fetched) {
//       setFetched(true);
//       setLoading(true);
//       load();
//     }
//   }, [fetched, load]);

//   const extra_filter = (obj: ModelBase | PlayerObject) => {
//     // Get creature_features that are not on anything.
//     if (obj instanceof CreatureAbility) {
//       for (const fs_type of FEATURE_SOURCE_TYPES) {
//         if (api.smart_hash[fs_type]) {
//           console.log(fs_type);
//           const fs = (api.smart_hash[fs_type] as FeatureSource[]).some(o => o.feature_bases.some(o2 => o2.features.some(o3 => o3.creature_feature_id === obj._id)));
//           if (fs) {
//             return false;
//           }
//         }
//       }
//       const ofb = ofbs.some(o => o.features.some(o3 => o3.creature_feature_id === obj._id));
//       if (ofb) {
//         return false;
//       }
//       const sfs = standard_features.some(o => o.feature_bases.some(o2 => o2.features.some(o3 => o3.creature_feature_id === obj._id)));
//       if (sfs) {
//         return false;
//       }
//       const transform = transforms.some(o => o.features.some(o3 => o3.creature_feature_id === obj._id));
//       if (transform) {
//         return false;
//       }
//       const creature = creatures.some(o => o.fbs.some(o2 => o2.features.some(o3 => o3.creature_feature_id === obj._id)));
//       if (creature) {
//         return false;
//       }
//       return true;
//     }
//     return false;
//   }

//   const deleteAll = () => {
//     // This deletes all the floating features that got through the extra filtering.
//     if (confirm("Are you sure? This will delete all the features that get through the extra_filter, regardless of the selected filtering.")) {
//       doDeleteAll();
//     }
//   }

//   const doDeleteAll = async () => {
//     const delete_us = api.all_creature_features.filter(o => extra_filter(o));
//     setLoading(true);
//     setLoadingMessage(`Deleting Features`);
//     for (let i = 0; i < delete_us.length; ++i) {
//       const delete_me = delete_us[i];
//       setLoadingMessage(`Deleting ${delete_me.name}`);
//       await api.deleteObject("creature_feature", delete_me);
//       setPercentage((i / delete_us.length) * 100);
//     }
//     setLoading(false);
//   }

//   if (!fetched || loading) {
//     return (
//       <div className="centered">
//         <LoadingBox size={window.innerHeight * 0.5} height={window.innerHeight - 81} message={loading_message} percentage={percentage} />
//       </div>
//     );
//   } else {
//     return (
//       <Grid container spacing={0} direction="row">
//         <Grid size={12}>
//           <ButtonBox name="Delete All"
//             onClick={deleteAll}
//           />
//         </Grid>
//         <Grid size={12}>
//           <NonFSIndex
//             data_type="creature_feature"
//             quick_fields={["feature_type"]}
//             // save_all
//             // extra_filter={(obj: ModelBase | PlayerObject) => {
//             //   if (obj instanceof SpellcastingFeature) {
//             //     console.log(obj.table);
//             //     return true;
//             //   }
//             //   return false;
//             // }}
//             extra_filter={extra_filter}
//             extra={(obj: ModelBase | PlayerObject) => {
//               // if (obj instanceof Modifier) {
//                 // Identify a thing that has it
//                 // for (const fs_type of FEATURE_SOURCE_TYPES) {
//                 //   if (api.smart_hash[fs_type]) {
//                 //     console.log(fs_type);
//                 //     const fs = (api.smart_hash[fs_type] as FeatureSource[]).find(o => o.feature_bases.filter(o2 => o2.features.filter(o3 => o3.creature_feature_id === obj._id).length > 0).length > 0);
//                 //     if (fs) {
//                 //       return <>In {fs_type}: {fs.true_name}</>;
//                 //     }
//                 //   }
//                 // }
//                 // const ofb = ofbs.find(o => 
//                 //   o.features.find(o3 => o3.creature_feature_id === obj._id)
//                 // );
//                 // if (ofb) {
//                 //   return <>In Optional Feature: {ofb.true_name}</>;
//                 // }
//                 // const transform = transforms.find(o => o.features.find(o3 => o3.creature_feature_id === obj._id));
//                 // if (transform) {
//                 //   return <>In Transform: {transform.true_name}</>;
//                 // }
//                 const creature = creatures.find(o => o.fbs.find(o2 => o2.features.find(o3 => o3.creature_feature_id === obj._id)));
//                 if (creature) {
//                   return <>In Creature: {creature.true_name}</>;
//                 }
//               // }
//               return <></>;
//             }}
//             // save_all
//             // display_format="{obj.true_name}"
//           />
//         </Grid>
//       </Grid>
//     );
//   }
// }

import React from 'react';
import NonFSIndex from "@dndComponents/NonFSIndex";

export default function CreatureFeatureIndex() {
  return (
    <NonFSIndex
      data_type="creature_feature"
      quick_fields={["feature_type"]}
    />
  );
}
